import EmailConfirmation from './email-confirmation';
export default EmailConfirmation;
